import { apiConnector } from "../apiConnector"
import { setData } from "../slice/dataSlice"
import { baseUrl } from "./api"

const{DATA_API}=baseUrl

export const getAllData = async (token) => {
    let result = []
    try {
        const response = await apiConnector("GET", DATA_API, null,{
            Authorization: `Bearer ${token}`,
        })
        // if (!response?.data?.success) {
        //     throw new Error("Could Not Fetch Course Categories")
        // }
        console.log("response", response)
        result = response?.data?.data
        console.log("result", result)
        setData(result)
    } catch (error) {
        console.log("GET_ALL_COURSE_API API ERROR............", error)
    }
    return result
}